import { useInfiniteQuery } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ZodError } from 'zod';
import { reviewsServiceDataSchema } from './review.schema';
import { Cookies } from 'react-cookie';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

const axiosTokenInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_REVIEW_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosTokenInst);

axiosTokenInst.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

type formData = {
  review_type: number;
  rating?: number;
  comment?: string;
};

export const addUpdateReview = async (orderId: string | undefined, formData: formData) => {
  try {
    const response = await axiosTokenInst.post(`/order/${orderId}`, formData);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

type Param = {
  page_number: number;
  items_per_page: number;
};

const GetReviews = async ({ pageParam, queryKey }: any) => {
  let params: Partial<Param> = {};
  params = {
    page_number: pageParam,
    items_per_page: 10,
  };
  try {
    const response = await axiosTokenInst.get(`restaurant/${queryKey[1]}`, { params });
    const parsedata = reviewsServiceDataSchema.parse(response.data);
    console.log(parsedata);

    return parsedata;
  } catch (error: unknown) {
    console.log(error);

    if (error instanceof ZodError) {
      toast.error('API validation failed');
    }
  }
};

export const useGetReviews = (resturantId: any) => {
  return useInfiniteQuery({
    queryKey: ['reviews', resturantId],
    queryFn: GetReviews,
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      return lastPage?.next_page;
    },
  });
};
